/**
 * Handoff Suite → apps produit (UI Kanakku split + apps natives).
 * Les ports viennent de @itaas/ports — ce fichier ne fixe que id IAM → clé produit + chemin d'atterrissage.
 */
export interface ModuleHandoffSpec {
  /** Clé produit dans ITAAS_PORT_REGISTRY (ex. procurement, inventoryKanakku). */
  portProduct: string;
  /** Route post-handoff sur l'app cible. */
  defaultPath: string;
}

/** Modules Kanakku extraits du hub Billing (juillet 2026). */
export const MODULE_HANDOFF_SPECS: Record<string, ModuleHandoffSpec> = {
  billing: { portProduct: "billing", defaultPath: "/index" },
  finance: { portProduct: "finance", defaultPath: "/index" },
  procurement: { portProduct: "procurement", defaultPath: "/suppliers" },
  inventory: { portProduct: "inventoryKanakku", defaultPath: "/branch" },
  product: { portProduct: "productKanakku", defaultPath: "/products" },
  crm: { portProduct: "crm", defaultPath: "/index" },
  erp: { portProduct: "erp", defaultPath: "/tenant/erp" },
  rh: { portProduct: "rh", defaultPath: "/tenant/dashboard" },
  workforce: { portProduct: "workforce", defaultPath: "/tenant/employees" },
  recruitment: { portProduct: "recruitment", defaultPath: "/tenant/recruitment" },
  attendance: { portProduct: "attendance", defaultPath: "/tenant/attendance/records" },
  security: { portProduct: "security", defaultPath: "/auth/handoff" },
  notifications: { portProduct: "erp", defaultPath: "/tenant/erp/notifications" },
  hospitol: { portProduct: "hospitol", defaultPath: "/tenant/hospitol" },
  edu: { portProduct: "edu", defaultPath: "/tenant/edu" },
  mineportal: { portProduct: "mineportal", defaultPath: "/tenant/mineportal" },
  subportal: { portProduct: "subportal", defaultPath: "/tenant/subportal" },
  comex: { portProduct: "comex", defaultPath: "/tenant/comex" },
  autoid: { portProduct: "autoid", defaultPath: "/tenant/autoid" },
  legal: { portProduct: "legal", defaultPath: "/tenant/legal" },
};

export function getModuleHandoffSpec(moduleId: string): ModuleHandoffSpec | undefined {
  return MODULE_HANDOFF_SPECS[moduleId];
}

export function getModuleDefaultPath(moduleId: string): string {
  return MODULE_HANDOFF_SPECS[moduleId]?.defaultPath ?? "/";
}
